import { render } from "./Traceability.vue?vue&type=template&id=7a544a44&scoped=true"
import script from "./Traceability.vue?vue&type=script&lang=js"
export * from "./Traceability.vue?vue&type=script&lang=js"

import "./Traceability.vue?vue&type=style&index=0&id=7a544a44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a544a44"]])

export default __exports__